import { __extends } from "tslib";
import { ClickableOption } from "@shop-builder/shared/ClickableOption";
var KissDeviceDetailColor = /*@__PURE__*/ (function (_super) {
    __extends(KissDeviceDetailColor, _super);
    function KissDeviceDetailColor(value, label, callback) {
        var _this = _super.call(this, value, label, callback) || this;
        _this.colorPlaceholder = "{COLOR}";
        _this.standardStyleClass = "mod-ep-kiss-device-detail__color-choice";
        _this.activeStyleClass = "mod-ep-kiss-device-detail__color-choice--active";
        _this.template = '<div class="mod-ep-kiss-device-detail__color-choice"><div class="mod-ep-kiss-device-detail__color-block" style=\"background:' + _this.colorPlaceholder + '\"></div></div>';
        _this.template = _this.template.replace(_this.colorPlaceholder, value);
        _this.setUp();
        return _this;
    }
    return KissDeviceDetailColor;
}(ClickableOption));
export { KissDeviceDetailColor };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/shop-builder/widgets/kiss-device-detail/kiss-device-detail-color.ts
// module id = null
// module chunks = 